import { useTranslation } from "react-i18next";
import { LogOut } from "lucide-react";

import type { AccountSignOutButtonProps } from "../../types";

const AccountSignOutButton = ({ onClick }: AccountSignOutButtonProps) => {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      className="account-popover-item account-popover-signout flex items-center gap-200"
      onClick={onClick}
    >
      <LogOut size={20} />

      <span className="account-popover-signout-label body-m-regular">
        {t("account.profileMenuItems.signOut")}
      </span>
    </button>
  );
};

export default AccountSignOutButton;
